import React from "react";
import {connect} from 'react-redux';
import Stats from './Stats';

class Intro extends React.Component{
    render() {
        let props = this.props;
        let form = props.form;
                return(
                    <div style={{'textAlign':"center"}}>
                        {/*{false && props && props.userData && props.userData.type !== 'public' && props.userData.name &&*/}
                        {/*    <div>*/}
                        {/*    <h4>Hi {props.userData.name}</h4>*/}

                        {/*Welcome to 9 To Know, a quick and easy way to take a look into your financial future.*/}
                        {/*<br/><br/>*/}
                        {/*Here you can obtain a complimentary basic financial analysis by entering 9 pieces of contact and financial information.*/}
                        {/*<br/><br/>*/}
                        {/*This analysis can help determine if you are on track for a successful retirement or if you may come up short. If you find the analysis doesn’t match your desired results, your advisor could provide recommendations that may help you attain your financial goals and improve your retirement picture.*/}
                        {/*<br/>*/}
                        {/*</div>*/}
                        {/*}*/}
                        <Stats step={0} {...this.props} disabled={form.disableGetStarted} />
                        {/*<br/><br/><br/>*/}
                        {/*{false && form.user && form.user.info && form.user.info.disclaimer &&*/}
                        {/*<div className={'text-center'}>*/}
                        {/*    <br/>*/}
                        {/*    <p style={{'fontSize': '10px','textAlign': 'justify'}}>*/}
                        {/*    {form.user.info.disclaimer}*/}
                        {/*</p>*/}
                        {/*</div>*/}
                        {/*}*/}
                    </div>
                );
    }
}
const mapStateToProps = (state, ownProps) => {
    return {
        ...state.mainState,
        ...ownProps
    }
  }

//   const mapDispatchToProps = { globalUpdateState }

  export default connect(
    mapStateToProps,
    null
    // mapDispatchToProps
  )(Intro)
